import type {ExampleData, DataCallbackOptions} from '../../Common';
import {addPerspectiveCameraOBJWithOrbitControls} from '../../ExampleUtils';

export function createData(options: DataCallbackOptions): ExampleData {
	const {scene} = options;
	const root = scene.root();
	const geo = root.createNode('geo');
	const sphere = geo.createNode('sphere');

	// add a noise
	const noise = geo.createNode('noise');
	noise.setInput(0, sphere);
	noise.p.amplitude.set(0.5);
	noise.p.useNormals.set(true);
	noise.flags.display.set(true);

	// add a light
	root.createNode('hemisphereLight');

	const {perspectiveCamera1} = addPerspectiveCameraOBJWithOrbitControls(root);

	return {
		scene,
		cameraPath: perspectiveCamera1.path(),
		focusedNodes: [noise],
		autoLayout: true,
	};
}
// export const sopNoise = [
// 	new Example({
// 		name: `${ExamplePrefix.BY_NODE}/sop/noise`,
// 		createData,
// 		relatedNodes: [NoiseSopNode],
// 	}),
// ];
